module.exports = __webpack_public_path__ + "static/media/service_mid.7d7d43d9.jpg";